<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
    
    	<el-form :inline="true" class="backborder1 demo-form-inline" size="small">
	        <el-form-item style="width:12%">
	            <el-date-picker v-model="query.start" type="month" format="yyyy-MM" value-format="yyyy-MM" style="width:100%"></el-date-picker>
	        </el-form-item>
	        <el-form-item>
	        	<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
	  		</el-form-item>
	  	</el-form>
    	
    	<!---------------- 图表 ------------------->
    	<div class="backborder5" style="width:18%;margin-top:10px" v-loading="amountLoading">
    		<span class="month">{{amounts.month}}</span>
			<el-tooltip placement="top">
				<div slot="content">销售出库单实付金额合计（包括客户、散客所下的已完成的订单）,实付金额-商品成本</div>
    			<span class="money">{{amounts.income.amount}}<i>{{amounts.income.unit}}</i></span>
			</el-tooltip>
    		<p class="desc">利润总额</p>
    		<table class="saz">
    			<tr>
					<td align="center">
						<el-tooltip placement="top">
							<div slot="content">当前已完成的销售出库单实付金额合计</div>
							<span>收入</span>
						</el-tooltip>
					</td>
					<td class="sr" style="width:48%;padding:2px 0 2px 2%;">{{amounts.sell.amount}}{{amounts.sell.unit}}</td></tr>
    			<tr>
					<td align="center">
						<el-tooltip placement="top">
							<div slot="content">当前已完成的销售出库单商品成本金额合计</div>
							<span>成本</span>
						</el-tooltip>
					</td>
					<td class="zc" style="width:48%;padding:2px 0 2px 2%;">{{amounts.cost.amount}}{{amounts.cost.unit}}</td></tr>
    		</table>
    	</div>
    	<div class="backborder5" style="width:76.5%;margin-left:1%;margin-top:10px">
			<IEcharts :option="income" :loading="incomeLoading"/>
    	</div>
    	
    	<!------------------- 内容 ----------------------->
    	<div class="backborder4" style="margin-top:10px;width:47%;height:150px" v-loading="amountLoading">
    		<div class="title"> 
    			<img src="../../static/images/income1.png"/>
    			<span>{{amounts.sell.amount}}{{amounts.sell.unit}}</span>
    			<p>收入总额（元）</p>
    		</div>
    		<table border="0">
    			<tr class="tl">
	    			<td width="30%">销售收入（元）</td>
	    			<td width="30%" align="left">{{amounts.sell.amount}}{{amounts.sell.unit}}</td>
	    			<td width="40%"><div class="percents"><h :style="{width:amounts.sell.percent}"></h></div><i>{{amounts.sell.percent}}</i></td>
    			</tr>
    		</table>
    	</div>
    	<div class="backborder4" style="margin-top:10px;width:47.5%;margin-left:1%;height:320px" v-loading="amountLoading">
			<div class="title"> 
    			<img src="../../static/images/income2.png"/>
    			<span>{{amounts.cost.amount}}{{amounts.cost.unit}}</span>
    			<p>成本总额（元）</p>
    		</div>
    		<table border="0">
    			<tr class="tl">
	    			<td width="30%">
						<el-tooltip placement="top">
							<div slot="content">已完成的销售出库单里出库类型为消费、赠送的商品成本合计</div>
							<span>销售成本（元）</span>
						</el-tooltip>
					</td>
	    			<td width="30%">{{amounts.sellcost.amount}}{{amounts.sellcost.unit}}</td>
	    			<td width="40%"><div class="percents"><h :style="{width:amounts.sellcost.percent}"></h></div><i>{{amounts.sellcost.percent}}</i></td>
    			</tr>
    			
    			<tr class="tr">
					<td>
						<el-tooltip placement="top">
							<div slot="content">已完成的销售出库单里出库类型为消费的商品成本合计</div>
							<span>消费成本</span>
						</el-tooltip>
					</td>
					<td>{{amounts.sellsalecost.amount}}{{amounts.sellsalecost.unit}}</td><td></td></tr>
    			<tr class="tr">
					<td>
						<el-tooltip placement="top">
							<div slot="content">已完成的销售出库单里出库类型为赠送的商品成本合计</div>
							<span>赠送成本</span>
						</el-tooltip>
					</td>
					<td>{{amounts.sellgivecost.amount}}{{amounts.sellgivecost.unit}}</td><td></td></tr>
    			
    			<tr class="tl">
	    			<td width="30%">
						<el-tooltip placement="top">
							<div slot="content">已完成的销售出库单里出库类型为自用、报废的商品成本合计</div>
							<span>商品类成本（元）</span>
						</el-tooltip>
					</td>
	    			<td width="30%">{{amounts.catecost.amount}}{{amounts.catecost.unit}}</td>
	    			<td width="40%"><div class="percents"><h :style="{width:amounts.catecost.percent}"></h></div><i>{{amounts.catecost.percent}}</i></td>
    			</tr>
    			
    			<tr class="tr">
					<td>
						<el-tooltip placement="top">
							<div slot="content">已完成的销售出库单里出库类型为自用的商品成本合计</div>
							<span>商品自用</span>
						</el-tooltip>
					</td>
					<td>{{amounts.sellmycost.amount}}{{amounts.sellmycost.unit}}</td><td></td></tr>
    			<tr class="tr">
					<td>
						<el-tooltip placement="top">
							<div slot="content">已完成的销售出库单里出库类型为报废的商品成本合计</div>
							<span>商品报废</span>
						</el-tooltip>
					</td>
					<td>{{amounts.sellbrokencost.amount}}{{amounts.sellbrokencost.unit}}</td><td></td></tr>
    		</table>
    	</div>
    	    	
    </div>
    </transition>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js';
export default {
    data () {
	    return {
	        url:this.GLOBAL.domain+"Datastat/index",
	        transitionshow:true,
	        actionauth:[],
	        amountLoading:false,
	        amounts:[],
	        query: {
	        	act:'getlocalincome',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1),
	        },
	        yearLoading:false,
	        years:[],
	        yearquery: {
	        	act:'yearincome',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1),
	        },
	        
	        income: {
	            legend: {
				   align: 'right',
				   data:['利润','收入','成本']
			    },
		  		xAxis: {			  
				   type: 'category', // 还有其他的type，可以去官网喵两眼哦
				   data: [], // x轴数据
				   name: '', //x轴名称
				   nameTextStyle: { //x轴名称样式
				       fontWeight: 600,
				       fontSize: 18,
				   }		  
		  		},
			    yAxis: {
				    type: 'value',
				    name: '', //y轴名称
				    nameTextStyle: { //y轴名称样式
					    fontWeight: 600,
					    fontSize: 18
				    }    
			    },
			    tooltip: {
				    trigger: 'axis' //axis item none三个值
			    },
		  
		  		incomeLoading:false,
		  		series: [
			    	{
			    		name: '利润',
				    	data: [],
				    	type: 'line',
					    itemStyle : {
							normal : {
								color:'#409EFF',
								lineStyle:{color:'#409EFF'}
							}
						},
			  		},
			  		{
			    		name: '收入',
			    		data: [],
			    		type: 'line',
					    itemStyle : {
							normal : {
								color:'#67C23A',
								lineStyle:{color:'#67C23A'}
							}
						},
			  		},
			  		{
			    		name: '成本',
			    		data: [],
			    		type: 'line',
					    itemStyle : {
							normal : {
								color:'#F56C6C',
								lineStyle:{color:'#F56C6C'}
							}
						},
			  		}
		  		]		  
      		},
	        
	        
	    }
    },
    
    
    components: {
    	IEcharts
  	},
  
    
    mounted(){
  		this.getactionauth(); //获取权限设置
  		this.getlocalincome(); //获取当前月销售信息
  		this.getyearshow(); //获取整年利润、收入、支出信息
    },
    
    methods:{    
	    /** 获取操作功能权限 **/
	  	getactionauth() {
	    	var data =this.$cookies.get('actionauth');
	    	data=JSON.parse(data);
	        this.actionauth=data;
	    },
	    
	    search() {
	    	this.getlocalincome(); //获取当前月销售信息
	    	this.getyearshow(); //获取整年利润、收入、支出信息
	    },
	    
	    /** 获取当前月销售信息 **/
	    getlocalincome() {
	    	this.amountLoading=true;
	    	var resource = this.$resource(this.url);
	        resource.query(this.query).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.amountLoading=false;
		        }else{
		            this.amounts = JSON.parse(Base64.decode(res.data.Data));
		            this.amountLoading=false;
		        }
	        }).catch((res) => {
	            this.amountLoading=false;
	        });	
	    },
	    
	    
	    /** 获取整年利润、收入、支出信息 **/
	    getyearshow() {
	    	this.yearquery.start=this.query.start;
	    
	    	this.yearLoading=true;
	    	var resource = this.$resource(this.url);
	        resource.query(this.yearquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.yearLoading=false;
		        }else{
		            this.years = JSON.parse(Base64.decode(res.data.Data));
		            this.income.xAxis.data=this.years.month; //时间段
                	this.income.series[0].data=this.years.income; //利润
                	this.income.series[1].data=this.years.sell; //收入
		            this.income.series[2].data=this.years.cost; //支出
		            this.yearLoading=false;
		        }
	        }).catch((res) => {
	            this.yearLoading=false;
	        });	
	    }, 
     
    }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.backborder5 {float:left;padding:2% 1% 2% 1%;height:300px;background:#fff;border:1px solid #ddd;border-radius:5px}
.backborder4 {float:left;padding:1% 1% 2% 1%;height:320px;background:#fff;border:1px solid #ddd;border-radius:5px}
.month {float:left;width:60%;margin:5% 0 0 20%;text-align:center;border-radius:15px;padding:3px 0 3px 0;font-size:14px;background:#F56C6C;color:#fff}
.money {float:left;text-align:center;width:100%;font-size:20px;color:#E6A23C;font-weight:bold;margin-top:15%}
.money i {font-style:normal;font-size:14px;font-weight:normal;}
.desc {float:left;width:100%;font-size:14px;text-align:center;padding:5px 0 10px 0;color:#909399;border-bottom:1px dashed #EBEEF5;margin-top:5%}
.saz {float:left;width:90%;font-size:14px;margin:5% 0 0 5%}
.saz td {width:50%;margin-top:0;padding:2px 0 2px 0;font-size:14px;color:#909399}
.saz .sr,.saz .zc {color:#606266;}
.backborder4 .title {float:left;width:96%;padding:2% 1% 2% 3%;background:#EBEEF5}
.backborder4 .title img  {float:left;width:8%}
.backborder4 .title span {float:left;width:60%;margin:3px 0 0 2%;font-size:20px;color:#E6A23C;font-weight:bold;line-height:20px;text-align:left}
.backborder4 .title p {float:left;width:60%;margin:5px 0 0 2%;font-size:14px;color:#E6A23C;line-height:18px;text-align:left}
.backborder4 table {float:left;width:100%;margin-top:10px}
.tl td .percents {float:left;width:50%;height:10px;margin-top:0.7em;border-radius:15px;background:#C0C4CC}
.tl td .percents h {float:left;height:10px;background:#ff8c42;border-radius:15px}
.tl td {font-size:14px;color:#606266;text-indent:3%;padding:1% 0 1% 0}
.tl td i {float:left;margin-left:5%;font-style:normal;color:#606266;}
.tr td {font-size:14px;color:#909399;text-indent:3%;padding:1% 0 1% 0}
</style>


// WEBPACK FOOTER //
// src/components/stat/Profitreport.vue